import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Styles from '../../Style/Common.module.css';
import BtnStyle from '../../Style/Button.module.css';
import { Link, useLocation } from "react-router-dom";
import { getCFDetailAPI, getWhyChooseusAPI, getServicesTypeAPI, getKeyAspectsAPI } from '../../../services/routes.services';
import parse from 'html-react-parser';
import constants from '../../../services/constants';
import Loader from "../../Common/PageLoader/LoadingSpinner";
import { IoCloseSharp } from "react-icons/io5";
import Breadcrumb from "./BreadCrumb";
import { useSelector } from 'react-redux';
import MenuPath from "../../Common/Header/CurrentPath";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CustomButtonGroup from "../../Common/CustomButtonGroup";
//icon
import { RxArrowTopRight } from "react-icons/rx";
const CertificationPage = ()=>{
    const serviceSlide = {
        superLargeDesktop: {breakpoint: { max: 4000, min: 3000 },items: 3,},
        desktop: {breakpoint: { max: 3000, min: 1024 },items: 3},
        tablet: {breakpoint: { max: 1024, min: 767 },items: 2},
        mobile: {breakpoint: { max: 767, min: 0 },items: 1}
    };
    const whyTQSlide = {
        superLargeDesktop: {breakpoint: { max: 4000, min: 3000 },items: 3},
        desktop: {breakpoint: { max: 3000, min: 1024 },items: 3},
        tablet: {breakpoint: { max: 1024, min: 580 },items: 2},
        mobile: {breakpoint: { max: 580, min: 0 },items: 1}
    };
    //math Path
    const location = useLocation();
    const { menu } = useSelector(state => state.header);
    const currentPageUrl = location.pathname;
    const currentMenuItem = MenuPath(menu, currentPageUrl);
    const BannerImage = currentMenuItem ? currentMenuItem.image : ''; 
    const BannerTitle = currentMenuItem ? currentMenuItem.parentTab : ''; 
// console.log(currentMenuItem?.parentTab,"currentmenu"   )

    const [loading, setLoading] = useState(true);
    const [whyChooseus, setWhyChooseus] = useState([]); 
    const [cfTrustData, setCFTrustData] = useState([]); 
    const [allServices, setAllServices] = useState([]); 
    const [WorkData, setworkData] = useState([]);
    useEffect(() => {
        Promise.all([
            getWhyChooseusAPI('certification'),
            getCFDetailAPI('certification'),
            getServicesTypeAPI("Certification & Technical Service"),
            getKeyAspectsAPI('overview'),
        ]).then(([whyChooseusRes, trustRes, allServicesRes, CFTworkRes ]) => {
            setWhyChooseus(whyChooseusRes?.data?.whychooseus[0]);
            setCFTrustData(trustRes?.data?.servicedetails[0]);
            setAllServices(allServicesRes.data.homeserviceimage);
            setworkData(CFTworkRes?.data?.iconservice[0])
            setLoading(false);
        }).catch(error => {
            console.log(error);
            setLoading(false);
        });
    }, [currentMenuItem]);
    const adjustPath = (path) => {
       
        // Example function to adjust paths
        return path.replace('/Certification/', '/');
       
    };
    if (loading) {
        return <Loader />;
    }
    console.log(whyChooseus)
    return(
        <div className={'CertificationPage ' + Styles.CertificationSec}>
            <div className={Styles.innerBanner + ' ' + Styles.InnerSmallBanner}>
              {BannerImage &&  <img src={constants.Image_BASE_URL+""+BannerImage} className={Styles.innerBannerimg} />}
                <div className={Styles.innerBannerContent}>
                    <Container>
                        <Row>
                            <Col>
                                <div className={Styles.detail}>
                                    <h2>{BannerTitle}</h2>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            <Breadcrumb />
            <div className={Styles.trustSec}>
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <div className={Styles.TrueHead}>
                                <h2>Globally Recognized Certifications for Compliance, Quality & Safety</h2>
                                {parse(cfTrustData?.description || "")}
                            </div>
                            <div className={Styles.trustElem}>
                                <div className={Styles.head}>
                                    <h3>Trust Signals</h3>
                                </div>
                                <Row>
                                    {cfTrustData?.fields && cfTrustData?.fields.map((item, index) =>(
                                        <Col key={index} className={Styles.trustCol}>
                                            <div className={Styles.trustBox}>
                                                <figure>
                                                    <img src={`${constants.Image_BASE_URL}${item?.image[0]?.fileName}`} />
                                                </figure>
                                                <p><strong>{item?.title}</strong></p>
                                                {parse(item?.description)}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={'servicesBlock ' + Styles.servicesSec + " " + Styles.blueSecBlock + " " + Styles.cftServicesSec + " " + Styles.maincft}>
                <Container>
                    <Row>
                        <Col>
                        <div className={Styles.servicesContainer}>
                            <h2>Service Offerings</h2>
                            <div className={'navBtn ' + Styles.servicesOwl}>
                            <Carousel
                                autoPlaySpeed={3000}
                                transitionDuration={500}
                                responsive={serviceSlide}
                                autoPlay={true}
                                infinite={true}
                                arrows={false}
                                customButtonGroup={<CustomButtonGroup />}
                                renderButtonGroupOutside={true}
                                containerClass="sectorOwl"
                            >
                                {allServices?.length > 0 && 
                                    allServices.filter(
                                            (item) =>
                                                item.text !== "Overview" &&
                                                item.text !== "Warehousing" &&
                                                item.text !== "SHE Services" &&
                                                item.text !== "Technical Services"
                                        ).sort((a, b) => a.order - b.order).map((item, index) =>{
                                        const adjustedLink = adjustPath(item.link);
                                        return(
                                            <div className={Styles.serviceItem} key={index}>
                                                <div className={Styles.itemBox}>
                                                    <img src={`${constants.Image_BASE_URL}${item?.image}`} alt={item?.text} />
                                                    <div className={Styles.content}>
                                                        <h3>{item?.text}</h3>
                                                        {parse(item?.description)}
                                                        <Link to={`${adjustedLink}`} className={BtnStyle.roundBtnLg + ' ' + BtnStyle.RoundRed}>
                                                            <RxArrowTopRight />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </Carousel>
                            </div>
                        </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={Styles.certificatWork}>
                <Container fluid>
                    <Row>
                        <Col>
                            <div className={Styles.certificatWorkContainer}>
                                <h2>How Certification Works</h2>
                                <ul>
                                    {WorkData && WorkData?.fields.map((item, index) =>(
                                        <li>
                                            <figure>
                                                <img src={`${constants.Image_BASE_URL}${item?.icon}`} alt="" />
                                            </figure>
                                            <p>{item?.title}</p>
                                        </li>
                                    ))}
                                    
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={'valuesSection ' + Styles.valueSec + " " + Styles.whuchooseSec + " " + Styles.owlStyle}>
                <Container fluid>
                <Row>
                    <Col>
                    <div className={Styles.valuesContainer}>
                        <h2>Why Choose TQ Cert Services? </h2>
                        <div className={'navBtn ' + Styles.valueOwl}>
                        <Carousel
                            autoPlaySpeed={3000}
                            transitionDuration={500}
                            responsive={whyTQSlide}
                            autoPlay={true}
                            infinite={true}
                            arrows={false}
                            customButtonGroup={<CustomButtonGroup />}
                            renderButtonGroupOutside={true}
                            containerClass="whyUsOwl"
                        >
                               {whyChooseus?.fields.length > 0 && whyChooseus?.fields?.map((item, index)=>{
                                return(
                                    <div className={Styles.valueSlide}  key={index}>
                                        <figure>
                                            {item.image[0] && <img src={constants.Image_BASE_URL+""+item.image[0].fileName} />}
                                        </figure>
                                        {parse(`${item.description}`)}
                                    </div>
                                )
                            })}
                        </Carousel>
                        </div>
                    </div>
                    </Col>
                </Row>
                </Container>
            </div>
            
        </div>
    )
}

export default CertificationPage;